import styled from 'styled-components'

export const ChipWrapper = styled.span`
  display: flex;
`
